import * as bootstrap from "bootstrap";
import htmx from "htmx.org/dist/htmx.esm";
import { attachChooserButtons } from "./spinnerbtn";

window.htmx = htmx;

window.document.addEventListener("success", handleEvent);
window.document.addEventListener("error", handleEvent);
window.document.addEventListener("info", handleEvent);
window.document.addEventListener("warn", handleEvent);

// Re-attach chooser buttons after htmx swaps content (for dynamic fragments)
document.body.addEventListener('htmx:afterSwap', function (evt) {
    try {
        attachChooserButtons(evt.target || document);
    } catch (e) {
        console.error('failed to attach chooser buttons after swap', e);
    }
});

document.body.addEventListener('htmx:responseError', function (e) {
    e.preventDefault();
    if (event.detail.xhr.status === 499) {
        window.location.reload()
    }
});

function handleEvent(e) {
    try {
        if (e.detail.dialog) {
            handleDialog(e.detail.dialog);
        }
        if (e.detail.toast) {
            handleToast(e.detail.toast);
        }
    } catch (error) {
        console.error("Error handling event:", error);
    }
}

function handleDialog(dialogDetail) {
    const modal = bootstrap.Modal.getInstance(document.querySelector(dialogDetail.selector));
    //TODO ไม่ทราบว่า ทำไมตัว show ถึงใช้ bootstrap.Modal.getInstance แล้วไม่ show และตัว hide ใช้ new bootstrap และไม่ hide เลย get มาสองตัวก่อน
    const showModal = new bootstrap.Modal(document.querySelector(dialogDetail.selector));
    if (modal || showModal) {
        if (dialogDetail.action === "HIDE") {
            modal.hide();
        } else if (dialogDetail.action === "SHOW") {
            console.log("test show dialog")
            showModal.show();
        } else {
            console.error("Unsupported dialog action:", dialogDetail.action);
        }
    } else {
        console.warn("Modal not found or not initialized");
    }
}

function base64DecodeUnicode(str) {
    let binaryString = atob(str);
    let bytes = new Uint8Array(binaryString.length);
    for (let i = 0; i < binaryString.length; i++) {
        bytes[i] = binaryString.charCodeAt(i);
    }
    let decodedText = new TextDecoder("utf-16le").decode(bytes);

    return decodeURIComponent(decodedText);
}

function handleToast(toastDetail) {
    Alpine.store("toast", {
        open: true,
        title: base64DecodeUnicode(toastDetail.title),
        message: base64DecodeUnicode(toastDetail.message),
        type: toastDetail.type
    });

    setTimeout(function () {
        Alpine.store("toast", {
            open: false,
            title: "",
            message: "",
            type: ""
        });
    }, 5000);
}